/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { List, MemberRole, MemberRoleOrGuest, OrganizationTeam } from "./data-contracts";

/**
 * No description
 * @tags space-teams
 * @name UpdateTeamPermissionInSpace
 * @summary Update a space team permission
 * @request PATCH:/spaces/{spaceId}/permissions/teams/{teamId}
 * @secure
 */

// @ts-ignore
export const updateTeamPermissionInSpace: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the Team */
    teamId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The role of a member in an organization, null for guests */
    role?: MemberRoleOrGuest;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/spaces/{spaceId}/permissions/teams/{teamId}",
  method: "patch",
  streaming: false,
  tags: ["space-teams"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-teams
 * @name RemoveTeamFromSpace
 * @summary Remove a space team
 * @request DELETE:/spaces/{spaceId}/permissions/teams/{teamId}
 * @secure
 */

// @ts-ignore
export const removeTeamFromSpace: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the Team */
    teamId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205 | 400;
} = {
  route: "/spaces/{spaceId}/permissions/teams/{teamId}",
  method: "delete",
  streaming: false,
  tags: ["space-teams"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-teams
 * @name ListTeamPermissionsInSpace
 * @summary List space team persmissions
 * @request GET:/spaces/{spaceId}/permissions/teams
 * @secure
 */

// @ts-ignore
export const listTeamPermissionsInSpace: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: {
      /**
       * "The role of a member in an organization.
       * "admin": Can administrate the content: create, delete spaces, ...
       * "create": Can create content.
       * "review": Can review content.
       * "edit": Can edit the content (live or change requests).
       * "comment": Can access the content and its discussions.
       * "read": Can access the content, but cannot update it in any way.
       */
      permission: MemberRole;
      team: OrganizationTeam;
    }[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/spaces/{spaceId}/permissions/teams",
  method: "get",
  streaming: false,
  tags: ["space-teams"],
  criticalityLevel: "low",
  deprecated: false,
};
